var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8424 14.4998C23.9444 15.0354 24 15.5953 24 16.1796C24 20.7501 20.8785 24 16.1638 24C15.0916 24.0003 14.0299 23.7936 13.0393 23.3917C12.0486 22.9898 11.1485 22.4005 10.3904 21.6576C9.63225 20.9146 9.03092 20.0326 8.62077 19.0618C8.21061 18.0911 7.99967 17.0507 8 16C7.99967 14.9493 8.21061 13.9089 8.62077 12.9382C9.03092 11.9674 9.63225 11.0854 10.3904 10.3424C11.1485 9.5995 12.0486 9.01024 13.0393 8.60831C14.0299 8.20639 15.0916 7.99968 16.1638 8C18.3681 8 20.21 8.7948 21.6232 10.0853L19.3218 12.3405V12.3348C18.4651 11.5351 17.3779 11.1247 16.1638 11.1247C13.4702 11.1247 11.2808 13.3547 11.2808 15.9951C11.2808 18.6347 13.4702 20.8696 16.1638 20.8696C18.6078 20.8696 20.2714 19.5002 20.6131 17.6197H16.1638V14.4998H23.8433H23.8424Z"
});

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7a69cfd0c3d8e08db36bd831eb3c86d3.svg";
export { ForwardRef as ReactComponent };